import {Step} from "./Step";

export class Pipe {
    constructor({
                    //attributes
                    id= null,
                    company_id= null,
                    title= "",
                    type= "",
                    created_at= new Date(),
                    updated_at= new Date(),
                    deleted_at= null,
                    //relations
                    steps=[],
                } = {}) {

        //fill attributes
        this.id=id;
        this.company_id=company_id;
        this.title=title;
        this.type=type;
        this.created_at=created_at;
        this.updated_at=updated_at;
        this.deleted_at=deleted_at;

        this.steps=(steps?steps:[]).map(step=>new Step(step));

    }
}

export function createPipe(data={}) {
    return Object.freeze(new Pipe(data));
}